<div class="p-3  fix-width">
    <div *ngIf="shareObject.data.type === 'list' || shareObject.data.type === 'deleted'">
        <h1 class="fw-bold fs-4 mb-3">{{'title_employee_store_manager'|translate}}</h1>
        <div *ngIf="shareObject.isLoading">
            <div class="">
                <div class="spinner-border spinner-border-sm text-secondary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        <div *ngIf="!shareObject.isLoading">
            <div class="mt-4 border-bottom">
                <!-- Search bar -->
                <div class="w-100 mb-2">
                    <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                        <div class="d-flex align-items-center gap-2">
                            <!-- button back  -->
                            <span class="btn btn-sm btn-warning  rounded-1" (click)="sharedService.back()">
                                <i class="bi bi-arrow-left"></i>
                                <span class="ms-2">{{'btn_back'|translate}}</span>
                            </span>
                            <!-- <span class="btn btn-sm btn-primary rounded-1" routerLink="/user/employee/calendar/create">
                                <i class="bi bi-plus-square"></i>
                                <span class="ms-2">{{'btn_add'|translate}}</span>
                            </span> -->
                            <!-- link to list deleted -->
                            <!-- <span *ngIf="sharedService.env.production===false && shareObject.data.type=='list' "
                                class="btn btn-sm btn-danger rounded-1" routerLink="/user/employee/calendar/deleted"
                                role="button">
                                <i class="bi bi-trash-fill"></i>
                                <span class="ms-2">{{'link_deleted'|translate}}</span>
                            </span> -->
                            <!-- soft delete  -->
                            <span
                                *ngIf="sharedService.env.production===false &&  shareObject?.selectedRows?.size> 0 && shareObject.data.type=='list'"
                                class="btn btn-sm btn-danger rounded-1"
                                (click)="softDeleteItem(shareObject?.selectedRows)" role="button">
                                <i class="bi bi-archive"></i>
                                <span class="ms-2">{{'btn_soft_delete'|translate}}</span>
                            </span>
                            <!-- restore many  -->
                            <span
                                *ngIf="sharedService.env.production===false &&  shareObject?.selectedRows?.size> 0 && shareObject.data.type=='deleted'"
                                class="btn btn-sm btn-success rounded-1"
                                (click)="restoreItem(shareObject?.selectedRows)" role="button">
                                <i class="bi bi-arrow-clockwise"></i>
                                <span class="ms-2">{{'btn_restore'|translate}}</span>
                            </span>
                            <!-- clear  -->
                            <span class="btn btn-sm btn-info rounded-1" (click)="clear()" role="button">
                                <i class="bi bi-arrow-clockwise"></i>
                                <span class="ms-2">{{'btn_clear'|translate}}</span>
                            </span>
                            <span class="btn btn-sm btn-primary rounded-1" (click)="shareObject.filterBox = true"
                                role="button">
                                <i class="bi bi-funnel"></i>
                                <span class="ms-2"> {{'btn_filter'|translate}} </span>
                            </span>

                        </div>
                    </div>
                    <!-- search box -->
                    <div style="z-index: 1050; width: 600px" class="position-absolute">
                        <form *ngIf="shareObject.filterBox===true" [formGroup]="filterForm"
                            class="advanced-filters shadow-lg bg-white border rounded p-3 mt-2">
                            <div class="row g-2">
                                <!-- store keyword -->
                                <div class="col-md-12">
                                    <label class="form-label fw-bold"
                                        for="keyword">{{'filter_keyword'|translate}}</label>
                                    <input type="text" class="form-control form-control-sm" formControlName="keyword"
                                        id="keyword">
                                </div>
                                <!-- page size -->
                                <div class="col-md-4">
                                    <label class="form-label fw-bold" for="pagesize">{{"page_size"|translate}}</label>
                                    <select class="form-select form-select-sm" formControlName="limit" id="pagesize">
                                        <option *ngFor="let size of sharedService.env.pageSize" value="{{size}}">
                                            {{size}}</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold"
                                        for="date">{{'filter_start_date'|translate}}</label>
                                    <input type="date" class="form-control form-control-sm" formControlName="startDate"
                                        id="startDate">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold" for="date">{{'filter_end_date'|translate}}</label>
                                    <input type="date" class="form-control form-control-sm" formControlName="endDate"
                                        id="endDate">
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label fw-bold" for="store">{{'filter_store'|translate}}</label>
                                    <select class="form-select form-select-sm" formControlName="store" id="store">
                                        <option value="">{{'store_all'|translate}}</option>
                                        <option value="empty">{{'store_empty'|translate}}</option>
                                        <option *ngFor="let store of shareObject.stores" value="{{store.id}}">
                                            {{store.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label fw-bold" for="group">{{'filter_group'|translate}}</label>
                                    <select class="form-select form-select-sm" formControlName="profile.employeeGroup"
                                        id="group">
                                        <option value="">{{'filter_group_all'|translate}}</option>
                                        <option *ngFor="let group of shareObject.employeeGroups" value="{{group.id}}">
                                            {{group.name}}
                                        </option>
                                    </select>
                                </div>
                                <!-- store keyword -->
                                <div class="col-md-3">
                                    <label class="form-label fw-bold mb-4" for="btns"></label>
                                    <div class=" d-flex gap-2" id="btns">
                                        <button class="btn btn-primary btn-sm rounded-1"
                                            (click)="onSearch()">{{'btn_filter'|translate}}</button>
                                        <button class="btn btn-secondary btn-sm rounded-1"
                                            (click)="shareObject.filterBox=false">{{'btn_close'|translate}}</button>
                                        <!-- <button class="btn btn-primary btn-sm rounded-1"
                        (click)="refresh()">{{'btn_clear'|translate}}</button> -->
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- filter result -->
                <div class="d-flex gap-2 mb-3 mt-2">
                    <button type="button" *ngIf="shareObject.options.keyword"
                        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
                        {{shareObject.options.keyword}}
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            (click)="filter('keyword',undefined)" role="button">x</span>
                    </button>
                    <button type="button" *ngIf="shareObject.options.filter.store"
                        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
                        {{shareObject.storeName}}
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            (click)="filter('store',undefined)" role="button">x</span>
                    </button>
                    <button type="button" *ngIf=" shareObject.groupName && filterForm.value['profile.employeeGroup']"
                        class="btn btn-outline-primary btn-sm rounded-1 position-relative">
                        {{shareObject.groupName}}
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                            (click)="filter('profile.employeeGroup',undefined)" role="button">x</span>
                    </button>
                </div>

            </div>
            <div class="fix-height">
                <table class="table table-hover table-striped table-sm">
                    <thead class="sticky-top bg-white">
                        <tr>
                            <th style="width: 50px;">
                                <div class="form-check">
                                    <input class="form-check-input" role="button" type="checkbox"
                                        [checked]="isAllSelected(shareObject.users)"
                                        (change)="toggleSelectAll($event,shareObject.users)" id="checkall">
                                    <label class="form-check-label" for="checkall"></label>
                                </div>
                            </th>
                            <!-- <th scope="col">{{'calendar_work_date'|translate}}</th> -->
                            <th scope="col">{{'employee_group'|translate}}</th>
                            <th scope="col">{{'store_employee'|translate}}</th>
                            <th scope="col">{{'store_name'|translate}}</th>
                            <th scope="col">{{'user_editor'|translate}}</th>
                            <th scope="col">{{'use_action'|translate}}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="shareObject.users && shareObject.users.length > 0 && !shareObject.isLoading">
                        <tr *ngFor="let item of shareObject.users; let i = index" (click)="selectRow($event, i)">
                            <td>
                                <div class="form-check">
                                    <input class="form-check-input" role="button" type="checkbox"
                                        [checked]="shareObject.selectedRows.has(i)" id="checkitem">
                                    <label class="form-check-label" for="checkitem"></label>
                                </div>
                            </td>
                            <!-- <td>{{item?.workDate | date:'dd/MM/yyyy'}}</td> -->
                            <td>{{item?.profile?.employeeGroup?.name}}</td>
                            <td>{{item?.profile?.name}}</td>
                            <td>
                                <div *ngIf="item?.store">
                                    <span *ngFor="let store of item?.store?.stores">
                                        <span role="button" class="badge py-1 rounded-pill text-bg-primary me-1"
                                            (click)="filterForm.patchValue({store:store?.id}); onSearch()">
                                            {{store?.name}}
                                        </span>
                                        <!-- <span class="me-2" (click)="showInfostore(store)">
                                            <i class="bi bi-info-circle" role="button"></i>
                                        </span> -->
                                    </span>
                                </div>
                                <div *ngIf="!item?.store">
                                    <span role="button"
                                        class="badge py-1 rounded-pill text-bg-secondary fst-italic me-1">
                                        {{'store_empty' | translate}}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span attr.data-title="{{item?.store?.user?.email}}">
                                    {{item?.store?.user?.profile?.name}}
                                </span>
                            </td>
                            <td>
                                <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'list'">
                                    <span class="btn btn-primary btn-sm rounded-1 py-0" *ngIf="item?.store"
                                        (click)="getStoreValue(item)">
                                        <i class="bi bi-pencil-square me-2"></i>
                                        {{'btn_edit'|translate}}
                                    </span>
                                    <span class="btn btn-success btn-sm rounded-1 py-0" *ngIf="!item?.store"
                                        (click)="sharedService.modalControl('#addstore')">
                                        <i class="bi bi-plus-circle me-2"></i>
                                        {{'btn_add'|translate}}
                                    </span>
                                    <span *ngIf="item?.store" class="btn btn-danger btn-sm rounded-1 py-0"
                                        (click)="deleteItem([i])">
                                        <i class="bi bi-archive me-2"></i>
                                        {{'btn_soft_delete'|translate}}
                                    </span>
                                </div>
                                <div class="d-flex gap-2" *ngIf="shareObject.data.type === 'deleted'">
                                    <span class="btn btn-success btn-sm rounded-1 py-0" (click)="restoreItem([i])">
                                        <i class="bi bi-arrow-clockwise me-2"></i>
                                        {{'btn_restore'|translate}}
                                    </span>
                                    <!-- <span class="btn btn-danger btn-sm rounded-1 py-0" (click)="softDeleteItem([item.id])">
                        <i class="bi bi-archive me-2"></i>
                        {{'btn_soft_delete'|translate}}
                      </span> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <caption *ngIf="shareObject.items && shareObject.items.length === 0">
                        <div class="text-center">
                            {{'no_calendar_found'|translate}}
                        </div>
                    </caption>
                    <caption *ngIf="shareObject.isLoading">
                        <div class="text-center">
                            <div class="spinner-border spinner-border-sm text-secondary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </caption>
                </table>
            </div>
            <app-pagination [pagingOptions]="shareObject.options" [pagination]="shareObject.pagination"
                (changePage)="onPageChange($event)"></app-pagination>
        </div>
    </div>
    <div *ngIf="shareObject.data.type === 'add' || shareObject.data.type === 'editbulk'">
        <h1 *ngIf="shareObject.data.type === 'add'" class="fw-bold fs-4 text-uppercase mb-3">
            {{"title_add_calendar"|translate}}</h1>
        <h1 *ngIf="shareObject.data.type === 'editbulk'" class="fw-bold fs-4 text-uppercase mb-3">
            {{"title_edit_calendar_bulk"|translate}}</h1>
        <!-- add account -->
        <div *ngIf="shareObject.isLoading">
            <div class="">
                <div class="spinner-border spinner-border-sm text-secondary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
        <div *ngIf="!shareObject.isLoading">
            <div>
                <form action="" [formGroup]="formHandle" (ngSubmit)="onSubmit()" class="p-3 row">
                    <!-- data employee -->
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 scroll-height  border mb-3">
                        <table class="table">
                            <thead class="sticky-top bg-white">
                                <tr class="">
                                    <th style="width: 50px;">
                                        <div class="form-check">
                                            <input class="form-check-input" role="button" type="checkbox"
                                                [checked]="isAllSelected(shareObject.users, 'userSelectedRows')"
                                                (change)="toggleSelectAll($event,shareObject.users, 'userSelectedRows')"
                                                id="checkall">
                                            <label class="form-check-label" for="checkall"></label>
                                        </div>
                                    </th>
                                    <th scope="col">
                                        <div class="d-flex gap-2">
                                            <span>{{'employee'|translate}}</span>
                                            <!-- <input type="text" #employee (keyup)="getUsers(employee.value)"
                                                class="form-control form-control-sm" id="email"> -->
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="">
                                <tr *ngFor="let item of shareObject.users; let i = index"
                                    (click)="selectRow($event, i, 'userSelectedRows')">
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" role="button" type="checkbox"
                                                [checked]="shareObject.userSelectedRows.has(i)" id="checkitem">
                                            <label class="form-check-label" for="checkitem"></label>
                                        </div>
                                    </td>
                                    <td>{{item.email}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- data store -->
                    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                        <table class="table border">
                            <thead>
                                <tr>
                                    <th style="width: 50px;">
                                        <div class="form-check">
                                            <input class="form-check-input" role="button" type="checkbox"
                                                [checked]="isAllSelected(shareObject.stores,'storeSelectedRows')"
                                                (change)="toggleSelectAll($event,shareObject.stores,'storeSelectedRows')"
                                                id="checkall">
                                            <label class="form-check-label" for="checkall"></label>
                                        </div>
                                    </th>
                                    <th scope="col">{{'store_name'|translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of shareObject.stores; let i = index"
                                    (click)="selectRow($event, i,'storeSelectedRows')">
                                    <td>
                                        <div class="form-check">
                                            <input class="form-check-input" role="button" type="checkbox"
                                                [checked]="shareObject.storeSelectedRows.has(i)" id="checkitem">
                                            <label class="form-check-label" for="checkitem"></label>
                                        </div>
                                    </td>
                                    <td>{{item.name}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- button save, back -->
                    <div class="d-flex gap-2">
                        <button type="submit" class="btn btn-primary btn-sm">{{'btn_add'|translate}}</button>
                        <span class="btn btn-warning btn-sm"
                            (click)="sharedService.back()">{{'btn_back'|translate}}</span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- modal add work calendar -->
<div class="modal" id="addstore" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{'store_select'|translate}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <table class="table border">
                        <thead>
                            <tr>
                                <th style="width: 50px;">
                                    <div class="form-check">
                                        <input class="form-check-input" role="button" type="checkbox"
                                            (change)="checkAll()" id="checkall">
                                        <label class="form-check-label" for="checkall"></label>
                                    </div>
                                </th>
                                <th scope="col">{{'store_name'|translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of shareObject.stores; let i = index">
                                <td>
                                    <div class="form-check">
                                        <input class="form-check-input" role="button" type="checkbox"
                                            [checked]="item.checked" (change)="checked(item.id)" id="checkitem">
                                        <label class="form-check-label" for="checkitem"></label>
                                    </div>
                                </td>
                                <td>{{item.name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    {{'btn_close'|translate}}
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()">{{'btn_save'|translate}}</button>
            </div>
        </div>
    </div>
</div>
<!-- <div class="modal fade" id="storeInfo" tabindex="-1" aria-labelledby="storeInfoLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content" *ngIf="shareObject.storeInfo">
            <div class="modal-header">
                <h5 class="modal-title" id="storeInfoLabel">{{shareObject.storeInfo.name}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="shareObject.storeInfo">
                    <div *ngFor="let item of shareObject.storeInfo.workDays; let i = index"
                        class="d-flex justify-content-between align-items-center mb-2">
                        <span>{{item.dayText}}</span>
                        <span class="badge bg-secondary" *ngIf="!item.isDayOff">
                            {{item.start }} - {{ item.end }}
                        </span>
                        <span class="badge bg-warning" *ngIf="item.isDayOff">
                            {{'store_dayoffs'|translate}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->